/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: { input: object; output: object; }
};

export enum AiExportStatus {
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotRequested = 'NOT_REQUESTED'
}

export type AiSuiteToggle = {
  __typename?: 'AiSuiteToggle';
  aiEnabled: Scalars['Boolean']['output'];
  entityId: Scalars['String']['output'];
  lastUpdated?: Maybe<LastUpdated>;
  lastUpdatedAt: Scalars['DateTime']['output'];
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
};

export type AiSuiteToggleUniqueFilter = {
  entityId?: InputMaybe<Scalars['String']['input']>;
};

export type AiUsageLogCreateParams = {
  context?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  feature: Scalars['String']['input'];
};

export type InitiateAiUsageExportPayload = {
  __typename?: 'InitiateAiUsageExportPayload';
  requestId: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
  status: AiExportStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LastUpdated = {
  __typename?: 'LastUpdated';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  initiateAiUsageExport: InitiateAiUsageExportPayload;
  recordAiUsage: RecordAiUsagePayload;
  upsertAiToggleState: AiSuiteToggle;
};


export type MutationInitiateAiUsageExportArgs = {
  entityId: Scalars['String']['input'];
};


export type MutationRecordAiUsageArgs = {
  obj: AiUsageLogCreateParams;
};


export type MutationUpsertAiToggleStateArgs = {
  obj: UpsertAiToggleParams;
};

export type Query = {
  __typename?: 'Query';
  aiToggleState: AiSuiteToggle;
  retrieveAiUsageExport: RetrieveAiUsageExportPayload;
};


export type QueryAiToggleStateArgs = {
  where: AiSuiteToggleUniqueFilter;
};


export type QueryRetrieveAiUsageExportArgs = {
  entityId: Scalars['String']['input'];
};

export type RecordAiUsagePayload = {
  __typename?: 'RecordAiUsagePayload';
  success: Scalars['Boolean']['output'];
};

export type RetrieveAiUsageExportPayload = {
  __typename?: 'RetrieveAiUsageExportPayload';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  status: AiExportStatus;
};

export type UpsertAiToggleParams = {
  aiEnabled: Scalars['Boolean']['input'];
  entityId: Scalars['String']['input'];
};

export type GetBnpAiToggleStateQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type GetBnpAiToggleStateQuery = { __typename?: 'Query', aiToggleState: { __typename?: 'AiSuiteToggle', aiEnabled: boolean } };


export const GetBnpAiToggleStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBnpAiToggleState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToggleState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiEnabled"}}]}}]}}]} as unknown as DocumentNode<GetBnpAiToggleStateQuery, GetBnpAiToggleStateQueryVariables>;

export const anAiSuiteToggle = (overrides?: Partial<AiSuiteToggle>): AiSuiteToggle => {
    return {
        aiEnabled: overrides && overrides.hasOwnProperty('aiEnabled') ? overrides.aiEnabled! : true,
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'tempore',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : aLastUpdated(),
        lastUpdatedAt: overrides && overrides.hasOwnProperty('lastUpdatedAt') ? overrides.lastUpdatedAt! : '2007-03-07T18:20:24.000+00:00',
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'optio',
    };
};

export const anAiSuiteToggleUniqueFilter = (overrides?: Partial<AiSuiteToggleUniqueFilter>): AiSuiteToggleUniqueFilter => {
    return {
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'voluptatem',
    };
};

export const anAiUsageLogCreateParams = (overrides?: Partial<AiUsageLogCreateParams>): AiUsageLogCreateParams => {
    return {
        context: overrides && overrides.hasOwnProperty('context') ? overrides.context! : 'consequatur',
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'suscipit',
        feature: overrides && overrides.hasOwnProperty('feature') ? overrides.feature! : 'eaque',
    };
};

export const anInitiateAiUsageExportPayload = (overrides?: Partial<InitiateAiUsageExportPayload>): InitiateAiUsageExportPayload => {
    return {
        requestId: overrides && overrides.hasOwnProperty('requestId') ? overrides.requestId! : 'error',
        requestedAt: overrides && overrides.hasOwnProperty('requestedAt') ? overrides.requestedAt! : '2007-01-24T10:15:36.000+00:00',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : AiExportStatus.Complete,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : '1994-06-09T15:00:01.000+00:00',
    };
};

export const aLastUpdated = (overrides?: Partial<LastUpdated>): LastUpdated => {
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'eveniet',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'perspiciatis',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'voluptatum',
    };
};

export const aMutation = (overrides?: Partial<Mutation>): Mutation => {
    return {
        initiateAiUsageExport: overrides && overrides.hasOwnProperty('initiateAiUsageExport') ? overrides.initiateAiUsageExport! : anInitiateAiUsageExportPayload(),
        recordAiUsage: overrides && overrides.hasOwnProperty('recordAiUsage') ? overrides.recordAiUsage! : aRecordAiUsagePayload(),
        upsertAiToggleState: overrides && overrides.hasOwnProperty('upsertAiToggleState') ? overrides.upsertAiToggleState! : anAiSuiteToggle(),
    };
};

export const aQuery = (overrides?: Partial<Query>): Query => {
    return {
        aiToggleState: overrides && overrides.hasOwnProperty('aiToggleState') ? overrides.aiToggleState! : anAiSuiteToggle(),
        retrieveAiUsageExport: overrides && overrides.hasOwnProperty('retrieveAiUsageExport') ? overrides.retrieveAiUsageExport! : aRetrieveAiUsageExportPayload(),
    };
};

export const aRecordAiUsagePayload = (overrides?: Partial<RecordAiUsagePayload>): RecordAiUsagePayload => {
    return {
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : true,
    };
};

export const aRetrieveAiUsageExportPayload = (overrides?: Partial<RetrieveAiUsageExportPayload>): RetrieveAiUsageExportPayload => {
    return {
        downloadUrl: overrides && overrides.hasOwnProperty('downloadUrl') ? overrides.downloadUrl! : 'tenetur',
        errorMessage: overrides && overrides.hasOwnProperty('errorMessage') ? overrides.errorMessage! : 'quo',
        filename: overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'cumque',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : AiExportStatus.Complete,
    };
};

export const anUpsertAiToggleParams = (overrides?: Partial<UpsertAiToggleParams>): UpsertAiToggleParams => {
    return {
        aiEnabled: overrides && overrides.hasOwnProperty('aiEnabled') ? overrides.aiEnabled! : false,
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'est',
    };
};
